var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showBadge)?_c('div',{staticClass:"badge",class:{ special: _setup.isSpecial }},[(_setup.isSpecial)?_c('FontAwesomeIcon',{attrs:{"icon":"star","size":"sm"}}):_vm._e(),(_setup.isProUser)?_c('FontAwesomeIcon',{attrs:{"icon":"crown","size":"sm"}}):_vm._e(),_c('span',[_vm._v(_vm._s(_setup.displayRole))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }